import { toDate } from '@superbet-group/web.lib.utilities';

import { TransactionDtoType } from '@core/mappers/transaction/dtos/transactionDtos';
import {
    BankWithdrawalResponseDto,
    OnlineWithdrawalResponseDto,
    PixWithdrawalResponseDto,
    ShopWithdrawalResponseDto,
    TransaksWithdrawalResponseDto,
    WithdrawalResponseDto,
} from '@core/mappers/user/dtos/WithdrawalResponseDto';
import { WithdrawalType } from '@core/models/user/enums';
import WithdrawalResponse from '@core/models/user/withdrawal/WithdrawalResponse';
import { PaymentStatus } from '@superbet-group/web.types';

export function transformWithdrawalResponse(dto: WithdrawalResponseDto, type: WithdrawalType): WithdrawalResponse {
    let typedDto;
    switch (type) {
        case WithdrawalType.BankTransfer:
            typedDto = dto as unknown as BankWithdrawalResponseDto;
            return {
                kind: TransactionDtoType.BankWithdrawal,
                transactionCode: typedDto.TransactionId,
                amount: typedDto.Parameters?.NetAmount,
                status: PaymentStatus[typedDto.StatusCode],
            };
        case WithdrawalType.Shop:
        case WithdrawalType.Instant:
            typedDto = dto as unknown as ShopWithdrawalResponseDto;
            return {
                kind: TransactionDtoType.OtherWithdrawal,
                transactionCode: typedDto.transactionCode,
                withdrawalDate: toDate(typedDto.withdrawalDate),
                status: PaymentStatus[typedDto.StatusCode],
            };
        case WithdrawalType.Transaks:
            typedDto = dto as unknown as TransaksWithdrawalResponseDto;
            return {
                kind: TransactionDtoType.TransaksWithdrawal,
                transactionCode: typedDto.payment_id,
                withdrawalDate: toDate((new Date()).toString()),
                status: PaymentStatus.Success,
            };
        case WithdrawalType.OnlinePix:
            typedDto = dto as unknown as PixWithdrawalResponseDto;
            return {
                kind: TransactionDtoType.PixWithdrawal,
                provider: typedDto.provider,
                transactionCode: typedDto.TransactionId ?? undefined,
                amount: typedDto.Parameters?.NetAmount,
                status: PaymentStatus[typedDto.StatusCode],
            };
        default:
            typedDto = dto as unknown as OnlineWithdrawalResponseDto;
            return {
                kind: TransactionDtoType.NuveiWithdrawal,
                transactionCode: typedDto.TransactionId ?? undefined,
                redirectUrl: typedDto.RedirectURL ?? undefined,
                amount: typedDto.Parameters?.NetAmount,
                status: PaymentStatus[typedDto.StatusCode],
            };
    }
}
